import {
  FETCH_EDGE_CONTROLLER_DEVICE,
  FETCH_EDGE_CONTROLLER_DEVICE_SUCCESS,
  FETCH_EDGE_CONTROLLER_DEVICE_FAILURE,
  CLEAR_EDGE_CONTROLLER_DEVICE,
} from './actions';

const initialState = {
  deviceData: null,
  isFetching: false,
};

export default function edgeControllerDetailsReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_EDGE_CONTROLLER_DEVICE:
      return { ...state, isFetching: true };

    case FETCH_EDGE_CONTROLLER_DEVICE_SUCCESS:
      return { ...state, isFetching: false, deviceData: action.payload };

    case FETCH_EDGE_CONTROLLER_DEVICE_FAILURE:
      return { ...state, isFetching: false, deviceData: null };

    case CLEAR_EDGE_CONTROLLER_DEVICE:
      return initialState;

    default:
      return state;
  }
}

